/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\externalevents.genclient.json
 */

"use strict";

export interface AzureContainerRegistryPushData {
    action: string;
}

export interface AzureContainerRegistryRepository {
    host: string;
    repoName: string;
    tag: string;
}

export interface DockerHubPushData {
    /**
     * Identifer of the repo on the external system.
     */
    pushedAt: number;
    pusher: string;
    tag: string;
}

export interface DockerHubRepository {
    name: string;
    namespace: string;
    repoName: string;
    repoUrl: string;
}

export interface ExternalAzureContainerRegistryPushEvent {
    /**
     * Property bag.  Subscription publisher inputs are copied here.
     */
    properties: { [key: string] : string; };
    /**
     * Identifer of the repo on the external system.
     */
    pushData: AzureContainerRegistryPushData;
    /**
     * Identifer of the repo on the external system.
     */
    repositoryData: AzureContainerRegistryRepository;
}

export interface ExternalBuildCompletionEvent {
    /**
     * Json blob containing the details of the external build
     */
    details: string;
    /**
     * The Duration of the build
     */
    duration: any;
    /**
     * Identifer of the build on the external system. External-system specific.
     */
    id: string;
    /**
     * Name of the build on the external system. External-system specific.
     */
    name: string;
    pipelineEventId: string;
    /**
     * Property bag.  Subscription publisher inputs are copied here.
     */
    properties: { [key: string] : string; };
    /**
     * This string identifies the publisher that received the message.
     */
    publisherId: string;
    /**
     * This string identifies the external source that sent the message.
     */
    sourceId: string;
    /**
     * Who started the build
     */
    startedBy: string;
    /**
     * When the build started
     */
    startTime: Date;
    /**
     * The Status of the build (see BuildStatus)
     */
    status: ExternalBuildStatus;
}

export enum ExternalBuildStatus {
    /**
     * Unknown status.
     */
    Unknown = 0,
    /**
     * The build is currently in progress.
     */
    InProgress = 1,
    /**
     * The build has completed and succeeded.
     */
    Succeeded = 2,
    /**
     * The build has completed and failed.
     */
    Failed = 3,
    /**
     * The build was cancelled.
     */
    Canceled = 4,
    /**
     * The build has not yet started.
     */
    NotStarted = 5
}

export interface ExternalCheckRun {
    /**
     * Identifies the date and time when the check run was completed.
     */
    completedAt: Date;
    /**
     * The conclusion of the check run.
     */
    conclusion: string;
    /**
     * The ID of the CheckRun object.
     */
    id: string;
    /**
     * The name of the check for this check run.
     */
    name: string;
    /**
     * Identifies the date and time when the check run was started.
     */
    startedAt: Date;
    /**
     * The current status of the check run.
     */
    status: string;
    /**
     * The name of the workflow that own this check run.
     */
    workflowName: string;
}

export interface ExternalCommentEventCommand {
    /**
     * The keyword that is used to define the command
     */
    commandKeyword: string;
    /**
     * Remaining comment body after the command keyword
     */
    remainingParameters: string;
}

export interface ExternalDockerHubPushEvent {
    /**
     * A TFS project ID
     */
    projectId: string;
    /**
     * Property bag.  Subscription publisher inputs are copied here.
     */
    properties: { [key: string] : string; };
    /**
     * Identifer of the repo on the external system.
     */
    pushData: DockerHubPushData;
    /**
     * Name of the repo.
     */
    repository: DockerHubRepository;
}

export interface ExternalGitComment {
    /**
     * Bucket for storing external data source related properties
     */
    additionalProperties: { [key: string] : any; };
    /**
     * Body of the comment that was made on the commit
     */
    commentBody: string;
    /**
     * User who made the comment and is responsible for kicking off the build process
     */
    commentedBy: ExternalGitUser;
    /**
     * Id of the entire comment.
     */
    id: string;
    /**
     * Property bag.  Subscription publisher inputs are copied here.
     */
    properties: { [key: string] : string; };
    /**
     * Git repository of this push.
     */
    repo: ExternalGitRepo;
    /**
     * The sender who sent the issue  GitHub Note: The webhook payload includes both sender and pusher objects. Sender and pusher are the same user who initiated the push event, but the sender object contains more detail.
     */
    sender: ExternalGitUser;
    /**
     * Timestamp of when the comment was last updated. We need to check to make sure that the comment happened after the most recent update to a PR
     */
    updatedAt: string;
}

export interface ExternalGitCommit {
    /**
     * Bucket for storing external data source related properties
     */
    additionalProperties: { [key: string] : any; };
    /**
     * User that authored the commit.
     */
    author: ExternalGitUser;
    /**
     * The date the commit was created
     */
    commitedDate: Date;
    /**
     * User-supplied commit message.
     */
    message: string;
    /**
     * The date the commit was pushed
     */
    pushedDate: Date;
    /**
     * Git repository of this commit.
     */
    repo: ExternalGitRepo;
    /**
     * Identifer of the commit.
     */
    sha: string;
    /**
     * Browser-viewable URL of the commit.
     */
    webUrl: string;
}

export interface ExternalGitCommitComment extends ExternalGitComment {
    /**
     * Commit id where the comment originates from
     */
    commitId: string;
}

/**
 * Used when it's unclear what kind of ExternalGitEvent has been recevied, but later, more specific events will be received.
 */
export interface ExternalGitEventReference {
    pipelineEventId: string;
}

export interface ExternalGitIssue {
    /**
     * Indicates the issue action, for example deleted.
     */
    action: string;
    /**
     * Bucket for storing external data source related properties
     */
    additionalProperties: { [key: string] : any; };
    /**
     * The assignees that are on the issue
     */
    assignees: ExternalGitUser[];
    /**
     * The time and date when the Issue was closed
     */
    closedAt: string;
    /**
     * The time and date when the PR was created
     */
    createdAt: string;
    /**
     * The description of the issue
     */
    description: string;
    /**
     * Identifer of the issue on the external system. External-system specific.
     */
    id: string;
    /**
     * Issue number in a repository on the external system.
     */
    number: string;
    /**
     * Git repository of this push.
     */
    repo: ExternalGitRepo;
    /**
     * The sender who sent the issue  GitHub Note: The webhook payload includes both sender and pusher objects. Sender and pusher are the same user who initiated the push event, but the sender object contains more detail.
     */
    sender: ExternalGitUser;
    /**
     * Indicates whether the issue is "closed" or "open".
     */
    state: string;
    /**
     * Issue title.
     */
    title: string;
    /**
     * The time and date when the PR was updated
     */
    updatedAt: string;
    /**
     * The url for the issue.
     */
    url: string;
    /**
     * The web url for the issue.
     */
    webUrl: string;
}

export interface ExternalGitPullRequest {
    /**
     * The assignees that are on the pull request
     */
    assignees: ExternalGitUser[];
    /**
     * Association between the individual who created the PR and the target repo Examples: COLLABORATOR, OWNER, CONTRIBUTOR, MEMBER, FIRST_TIMER, FIRST_TIME_CONTRIBUTOR, NONE
     */
    authorAssociation: string;
    /**
     * Describes the build that should be retried when a GitHub check rerun is requested.
     */
    buildToRetry: string;
    /**
     * The time and date when the PR was closed
     */
    closedAt: string;
    /**
     * The commits that make up the pull request
     */
    commits: ExternalGitCommit[];
    /**
     * The time and date when the PR was created
     */
    createdAt: string;
    /**
     * Describes the definition that should be built if the pull request originates from a comment event. If all definitions should be built, it will be "all". If IsFromComment is false, this value won't be checked and can be set to null Also used to specify the definition to build when a GitHub check rerun is requested if we can't find the build by build id.
     */
    definitionToBuild: string;
    /**
     * The description of the pull request
     */
    description: string;
    /**
     * Indicates if the author of the PR has write access to the target repository
     */
    doesAuthorHaveWriteAccess: boolean;
    /**
     * Indicates whether the pull request is a draft.
     */
    draft: boolean;
    /**
     * Identifer of the push or pull request on the external system. External-system specific.
     */
    id: string;
    /**
     * Indicates whether the pull request is coming from a fork.
     */
    isFork: boolean;
    /**
     * Describes if the external git pull request originates from a comment event
     */
    isFromComment: boolean;
    /**
     * Indicates whether the pull request is mergable, i.e. null  - the merge job has not finished yet creating the merge commit; false - the pull request has conflicts and the merge commit cannot be created; true  - the merge commit has been successfully created and the MergeCommitSha field contains a correct value.
     */
    isMergeable: boolean;
    /**
     * The last commit made to the head ref of the PR
     */
    lastHeadRefCommit: ExternalGitCommit;
    /**
     * SHA of the merge commit.
     */
    mergeCommitSha: string;
    /**
     * The time and date when the pull request was merged
     */
    mergedAt: string;
    /**
     * Full name of the pull request merge branch. For example: refs/pull/5/merge
     */
    mergeRef: string;
    /**
     * Pull request number in a repository on the external system.
     */
    number: string;
    pipelineEventId: string;
    /**
     * A TFS project ID -- TODO find a better way of sending this info to build Also used for identifying the Azure DevOps project associated with a GitHub check rerun event.
     */
    projectId: string;
    /**
     * Property bag.  Subscription publisher inputs are copied here.
     */
    properties: { [key: string] : string; };
    /**
     * Git repository of this push.
     */
    repo: ExternalGitRepo;
    /**
     * The review status of a pull request. null - GH haven't returned Review Decision; Approved - The pull request has received an approving review; ChangesRequested - Changes have been requested on the pull request; ReviewRequired - A review is required before the pull request can be merged;
     */
    reviewDecision: string;
    /**
     * The sender who sent the pull request  GitHub Note: The webhook payload includes both sender and pusher objects. Sender and pusher are the same user who initiated the push event, but the sender object contains more detail.
     */
    sender: ExternalGitUser;
    /**
     * Full name of the source branch. For example: refs/heads/features/myfeature
     */
    sourceRef: string;
    /**
     * SHA of the source branch.
     */
    sourceSha: string;
    /**
     * Indicates whether the pull request is "closed" (merged or abandoned) or "open".
     */
    state: string;
    /**
     * Check and Status rollup information for this commit.
     */
    statusCheckResults: { [key: string] : ExternalCheckRun[]; };
    /**
     * Full name of the target branch. For example: refs/heads/master
     */
    targetRef: string;
    /**
     * SHA of the targer branch.
     */
    targetSha: string;
    /**
     * Pull request title.
     */
    title: string;
    /**
     * The time and date when the PR was updated
     */
    updatedAt: string;
    /**
     * The url for the pull request.
     */
    url: string;
    /**
     * The web url for the pull request.
     */
    webUrl: string;
}

export interface ExternalGitPush {
    /**
     * SHA of the branch after the push.
     */
    afterSha: string;
    /**
     * SHA of the branch prior to the push.
     */
    beforeSha: string;
    /**
     * Describes the build that should be retried when a GitHub check rerun is requested.
     */
    buildToRetry: string;
    /**
     * Commits pushed.
     */
    commits: ExternalGitCommit[];
    /**
     * Describes the definition that should be built when a GitHub check rerun is requested if we can't find the build by build id.
     */
    definitionToBuild: string;
    /**
     * Identifer of the push on the external system. External-system specific.
     */
    id: string;
    pipelineEventId: string;
    /**
     * A TFS project ID -- TODO find a better way of sending this info to build Also used for identifying the Azure DevOps project associated with a GitHub check rerun event.
     */
    projectId: string;
    /**
     * Property bag.  Subscription publisher inputs are copied here.
     */
    properties: { [key: string] : string; };
    /**
     * User that pushed.
     */
    pushedBy: ExternalGitUser;
    /**
     * Full name of the ref that was pushed to. For example: refs/heads/master.
     */
    ref: string;
    /**
     * Git repository of this push.
     */
    repo: ExternalGitRepo;
}

export interface ExternalGitRepo {
    /**
     * Bucket for storing external data source related properties
     */
    additionalProperties: { [key: string] : any; };
    /**
     * The default branch of the repo.
     */
    defaultBranch: string;
    /**
     * Identifer of the repo on the external system.
     */
    id: string;
    /**
     * Is this repo private.
     */
    isPrivate: boolean;
    /**
     * Name of the repo.
     */
    name: string;
    /**
     * Clone URL of the repo.
     */
    url: string;
    /**
     * Browser-viewable URL of the repo.
     */
    webUrl: string;
}

export interface ExternalGitUser {
    /**
     * Bucket for storing external data source related properties
     */
    additionalProperties: { [key: string] : any; };
    /**
     * URL of the user's avatar image.
     */
    avatarUrl: string;
    /**
     * Email address of the user.
     */
    email: string;
    /**
     * Name or login of the user depending on the source of the data.
     */
    name: string;
    /**
     * Type of the user. For example, "User" or "Bot".
     */
    type: string;
}

export interface ExternalPullRequestCommentEvent extends ExternalGitComment {
    /**
     * Indicates the comment action, for example deleted.
     */
    action: string;
    /**
     * Association of the individual who created the comment
     */
    authorAssociation: string;
    /**
     * Describes the command that was used when making the comments. Corresponds to some action that we should respond to
     */
    command: ExternalCommentEventCommand;
    pipelineEventId: string;
    /**
     * A TFS project ID
     */
    projectId: string;
    /**
     * The pull request that the comment was made on
     */
    pullRequest: ExternalGitPullRequest;
    /**
     * Pull request number in the repository where the comment originates from
     */
    pullRequestNumber: string;
    /**
     * Owner of the repository where the comment on the PR was made
     */
    repositoryOwner: string;
}

export interface ExternalRateLimit {
    limit: number;
    remaining: number;
}

export var TypeInfo = {
    ExternalBuildCompletionEvent: <any>{
    },
    ExternalBuildStatus: {
        enumValues: {
            "unknown": 0,
            "inProgress": 1,
            "succeeded": 2,
            "failed": 3,
            "canceled": 4,
            "notStarted": 5
        }
    },
    ExternalCheckRun: <any>{
    },
    ExternalGitCommit: <any>{
    },
    ExternalGitPullRequest: <any>{
    },
    ExternalGitPush: <any>{
    },
    ExternalPullRequestCommentEvent: <any>{
    },
};

TypeInfo.ExternalBuildCompletionEvent.fields = {
    startTime: {
        isDate: true,
    },
    status: {
        enumType: TypeInfo.ExternalBuildStatus
    }
};

TypeInfo.ExternalCheckRun.fields = {
    completedAt: {
        isDate: true,
    },
    startedAt: {
        isDate: true,
    }
};

TypeInfo.ExternalGitCommit.fields = {
    commitedDate: {
        isDate: true,
    },
    pushedDate: {
        isDate: true,
    }
};

TypeInfo.ExternalGitPullRequest.fields = {
    commits: {
        isArray: true,
        typeInfo: TypeInfo.ExternalGitCommit
    },
    lastHeadRefCommit: {
        typeInfo: TypeInfo.ExternalGitCommit
    },
    statusCheckResults: {
        isDictionary: true,
        dictionaryValueFieldInfo: {
            isArray: true,
            typeInfo: TypeInfo.ExternalCheckRun
        }
    }
};

TypeInfo.ExternalGitPush.fields = {
    commits: {
        isArray: true,
        typeInfo: TypeInfo.ExternalGitCommit
    }
};

TypeInfo.ExternalPullRequestCommentEvent.fields = {
    pullRequest: {
        typeInfo: TypeInfo.ExternalGitPullRequest
    }
};
